import React from 'react'
import { Box, Heading } from '@chakra-ui/react'
import { handleSpecificLabelCategory } from '../../../filters'

const Category = ({ item, lang, fontFamily, accentColor }) => {
  return (
    <Box w='100%' pt='.5rem'>
      <Heading
        color='brand.cardCategory'
        fontSize={['md', 'md', 'sm', 'sm']}
        fontFamily={fontFamily}
        fontWeight='400'
      >
        {handleSpecificLabelCategory(lang, item.raw_category)}
      </Heading>
    </Box>
  )
}

export default Category
